import React from 'react';
import './styles/CustomDots.scss';

const CustomDot = () => {
  return <div className="slickSlider-customDot" />;
};

export default CustomDot;
